import * as React from "react";

import {getAbsLink} from "../get-abs-link";

import {InternalLink, MenuInternalLink} from "./internal-link";

export const FlexInternalLink = ({href = undefined, to = undefined, navBlock=undefined, ...props}) => href ? (
    <a
        href={href}
        onClick={async (e) => {
            e.preventDefault();
            if (await navBlock?.block() === true) {
                return;
            }
            window.location.href = href;
        }}
        {...props}
    />
) : (
    InternalLink({
        to: to,
        navBlock,
        ...props,
    })
);

export const FlexMenuInternalLink = ({href = undefined, to = undefined, navBlock=undefined, ...props}) => (
    href ? (
        <a
            href={href}
            {...props}
        />
    ) : (
        MenuInternalLink({
            to,
            navBlock,
            ...props,
        })
    )
);
